import React, {FunctionComponent} from "react";
import {Link} from "gatsby";
import useTranslateOrDefault from "../hooks/useTranslateOrDefault";

type Props = {
    link: string;
};

const FeedbackLink: FunctionComponent<Props> = ({link}) => {
    const defaultLinkText = "Questions? Hints? Discuss in with our community!";

    return (
      <div>
          <div className="feedbackLink">
              <hr/>
              <Link to={link}
                    title={useTranslateOrDefault("feedback-link-text", defaultLinkText)}>
                  <span><i className="fa fa-comments"/> {useTranslateOrDefault("feedback-link-text", defaultLinkText)}</span>
              </Link>
          </div>
      </div>

    );
}

export default FeedbackLink;